module.exports = __webpack_public_path__ + "static/palm_tree_02-381debfa17c3a4536eefe08a7063441e.png";